import React, {FC} from 'react';
import styles from './menu.module.scss';

import {useRef, useState} from 'react';
import {ControlledMenu, MenuItem, useHover} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css'
import { Link } from "react-router-dom";

const Menu = ({title, menuItems}) => {
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const {anchorProps, hoverProps} = useHover(isOpen, setOpen);


    return (
        <>
            <div className={styles.Menu}>
            <button ref={ref} {...anchorProps}>
                {title}
            </button>

            <ControlledMenu
                {...hoverProps}
                state={isOpen ? "open" : "closed"}
                anchorRef={ref}
                onClose={() => setOpen(false)}
            >
                {menuItems.map((item) => (
                    <MenuItem key={item.title}>
                        <Link to={item.url} className="menuLink">{item.title}</Link>
                    </MenuItem>
                ))}
            </ControlledMenu>
            </div>

        </>
    );
};


export default Menu;
